import React, { useRef, useLayoutEffect, useState } from "react";
import PropTypes from 'prop-types';

const ArrowPipeline = ({
    stages,
    currentStage,
    onStageClick,
    completedColor = "#0d6efd",
    upcomingColor = "#d3d3d3",
    arrowHeight = 50,
    disabledItem,
    UpdatePs, canUpdateDelete,
    displayData
}) => {

    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(null);

    // useEffect(() => {
    //     if (!containerRef.current) return;

    //     const resizeObserver = new ResizeObserver(() => {
    //         if (containerRef.current) {
    //             setContainerWidth(containerRef.current.offsetWidth);
    //         }
    //     });

    //     resizeObserver.observe(containerRef.current);

    //     // Initial width set
    //     setContainerWidth(containerRef.current.offsetWidth);

    //     return () => resizeObserver.disconnect();
    // }, []);
    useLayoutEffect(() => {
        if (!containerRef.current) return;

        const resizeObserver = new ResizeObserver(() => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.offsetWidth);
            }
        });

        resizeObserver.observe(containerRef.current);
        setContainerWidth(containerRef.current.offsetWidth);

        return () => resizeObserver.disconnect();
    }, []);

    const arrowWidth = containerWidth / stages.length;

    return (
        // <div ref={containerRef} style={{ width: "100%" }}>
        //     <svg height={arrowHeight} width={containerWidth} style={{ fontFamily: "sans-serif" }}>
        //         {stages.map((stage, i) => {
        //             const { leadStatusId, leadStatusName } = stage;
        //             const isLast = i === stages.length - 1;
        //             const isFirst = i === 0;
        //             const isCompleted = i <= currentStage - 1;
        //             const x = i * arrowWidth;

        //             let points;
        //             if (isFirst) {
        //                 points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight}`;
        //             } else if (isLast) {
        //                 points = `${x},0 ${x + arrowWidth},0 ${x + arrowWidth},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
        //             } else {
        //                 points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
        //             }

        //             return (
        //                 // <g
        //                 //     key={leadStatusId}
        //                 //     onClick={() => (disabledItem || i === currentStage - 1) ? undefined : onStageClick(leadStatusId)}
        //                 //     style={{ cursor: (disabledItem || i === currentStage - 1) ? "default" : "pointer" }}
        //                 // >
        //                 <g
        //                     key={leadStatusId}
        //                     onClick={() => !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? undefined :
        //                         displayData?.approved_for === "None" ?
        //                             (disabledItem || i === currentStage - 1) ? undefined : onStageClick(leadStatusId) : undefined}
        //                     onMouseEnter={() => !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? undefined :
        //                         displayData?.approved_for === "None" ? setHoveredIndex(i) : undefined}
        //                     onMouseLeave={() => !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? undefined :
        //                         displayData?.approved_for === "None" ? setHoveredIndex(null) : undefined}
        //                     style={{
        //                         cursor: !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? "default" :
        //                             displayData?.approved_for === "None" ?
        //                                 (disabledItem || i === currentStage - 1) ? "default" : "pointer" : "default"
        //                     }}
        //                 >
        //                     <polygon points={points} fill={
        //                         !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? upcomingColor :
        //                             displayData?.approved_for === "None" ?
        //                                 hoveredIndex !== null && i <= hoveredIndex
        //                                     ? completedColor // or any hover color you prefer
        //                                     : isCompleted
        //                                         ? completedColor
        //                                         : upcomingColor : upcomingColor
        //                     } />
        //                     <text
        //                         fontFamily="'Noto Sans', sans-serif"
        //                         x={x + arrowWidth / 2}
        //                         y={arrowHeight / 2}
        //                         textAnchor="middle"
        //                         fill={!canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? "#a1a1a1" :
        //                             displayData?.approved_for === "None" ?
        //                                 hoveredIndex !== null && i <= hoveredIndex
        //                                     ? "#ffffff" :
        //                                     isCompleted ? "#ffffff" : "#a1a1a1" : "#a1a1a1"}
        //                         fontSize="12"
        //                         fontWeight="600"
        //                         dominantBaseline="middle"
        //                     >
        //                         {(() => {
        //                             const words = leadStatusName.split(" ");
        //                             if (words.length <= 2) {
        //                                 return <tspan>{words.join(" ")}</tspan>;
        //                             }

        //                             const mid = Math.ceil(words.length / 2);
        //                             const firstLine = words.slice(0, mid).join(" ");
        //                             const secondLine = words.slice(mid).join(" ");

        //                             return (
        //                                 <>
        //                                     <tspan x={x + arrowWidth / 2} dy="-5">{firstLine}</tspan>
        //                                     <tspan x={x + arrowWidth / 2} dy="14">{secondLine}</tspan>
        //                                 </>
        //                             );
        //                         })()}
        //                     </text>
        //                 </g>
        //             );
        //         })}
        //     </svg>
        // </div>
        <div ref={containerRef} style={{ width: "100%" }}>
            <svg height={arrowHeight} width={containerWidth} style={{ fontFamily: "sans-serif" }}>
                {stages.map((stage, i) => {
                    const { leadStatusId, leadStatusName } = stage;
                    const isLast = i === stages.length - 1;
                    const isFirst = i === 0;
                    const isCompleted = i <= currentStage - 1;

                    const canEdit = canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId);
                    const isApprovedNone = displayData?.approved_for === "None";
                    const x = i * arrowWidth;

                    let points;
                    if (isFirst) {
                        points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight}`;
                    } else if (isLast) {
                        points = `${x},0 ${x + arrowWidth},0 ${x + arrowWidth},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
                    } else {
                        points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
                    }

                    const isInteractive = canEdit && isApprovedNone;
                    const isHovered = hoveredIndex !== null && i <= hoveredIndex;

                    return (
                        <g
                            key={leadStatusId}
                            onClick={() => {
                                if (isInteractive && !disabledItem) {
                                    onStageClick(leadStatusId);
                                }
                            }}
                            onMouseEnter={() => {
                                if (isInteractive) setHoveredIndex(i);
                            }}
                            onMouseLeave={() => {
                                if (isInteractive) setHoveredIndex(null);
                            }}
                            style={{
                                cursor: isInteractive && !disabledItem ? "pointer" : "default",
                            }}
                        >
                            <polygon
                                points={points}
                                fill={
                                    isInteractive
                                        ? (isHovered ? completedColor : isCompleted ? completedColor : upcomingColor)
                                        : upcomingColor
                                }
                            />
                            <text
                                fontFamily="'Noto Sans', sans-serif"
                                x={x + arrowWidth / 2}
                                y={arrowHeight / 2}
                                textAnchor="middle"
                                fill={
                                    isInteractive
                                        ? (isHovered ? "#ffffff" : isCompleted ? "#ffffff" : "#a1a1a1")
                                        : "#a1a1a1"
                                }
                                fontSize="12"
                                fontWeight="600"
                                dominantBaseline="middle"
                            >
                                {(() => {
                                    const words = leadStatusName.split(" ");
                                    if (words.length <= 2) {
                                        return <tspan>{words.join(" ")}</tspan>;
                                    }

                                    const mid = Math.ceil(words.length / 2);
                                    const firstLine = words.slice(0, mid).join(" ");
                                    const secondLine = words.slice(mid).join(" ");

                                    return (
                                        <>
                                            <tspan x={x + arrowWidth / 2} dy="-5">{firstLine}</tspan>
                                            <tspan x={x + arrowWidth / 2} dy="14">{secondLine}</tspan>
                                        </>
                                    );
                                })()}
                            </text>
                        </g>
                    );
                })}
            </svg>
        </div>
    );
};

ArrowPipeline.propTypes = {
    stages: PropTypes.arrayOf(PropTypes.string).isRequired,
    currentStage: PropTypes.number.isRequired,
    onStageClick: PropTypes.func,
    completedColor: PropTypes.string,
    upcomingColor: PropTypes.string,
    arrowHeight: PropTypes.number,
    disabledItem: PropTypes.bool,
    UpdatePs: PropTypes.object.isRequired,
    displayData: PropTypes.object.isRequired,
    canUpdateDelete: PropTypes.func.isRequired,
};

export default ArrowPipeline;
